import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
import Path from '../constants/path';

const UnProtectedRoute = ({element}) => {
  const isAuthenticated = sessionStorage.getItem('isLoggedIn');
  const navigate = useNavigate();
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate(Path.lead_management, {replace: true});
    } else {
      setShouldRender(true);
    }
  }, [isAuthenticated, navigate]);

  return shouldRender ? element : null;
};

UnProtectedRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default UnProtectedRoute;
